import React, { useState } from 'react';
import AddOperatorModal from '../components/AddOperatorModal';
import OperatorsModal from '../components/OperatorsModal';
import VistaComoBar from '../components/VistaComoBar';
import AliasCuenta from '../components/AliasCuenta';
import ProfileModal from '../components/ProfileModal';
import { hoyAR } from '../components/SuscripcionNegocio';

// Colaboradores inventados para ver la gestión de operadores sin tocar Firestore.
const OPERADORES_DE_PRUEBA = [
    { email: 'caja1@ejemplo.com', nombre: 'Lucía Gómez', admin: false, limite_monto: 200000, createdAt: '2026-08-12T12:00:00.000Z' },
    { email: 'caja2@ejemplo.com', nombre: 'Martín Pérez', admin: false, createdAt: '2026-09-03T12:00:00.000Z' },
    { email: 'encargada@ejemplo.com', nombre: 'Sofía Ruiz', admin: true, createdAt: '2026-07-21T12:00:00.000Z' }
];

// Suscripción inventada con la forma de resumen() en functions/src/suscripciones.
function suscripcionDePrueba(estado, haceDias, diasPrueba = 7) {
    const fecha = (dias) => {
        const d = new Date(`${hoyAR()}T00:00:00Z`);
        d.setUTCDate(d.getUTCDate() + dias);
        return d.toISOString().slice(0, 10);
    };
    return {
        estado,
        inicio: fecha(-haceDias),
        dias_prueba: diasPrueba,
        vence: fecha(diasPrueba - haceDias),
        dias_restantes: diasPrueba - haceDias,
        monto: 29000,
    };
}

// Ya suscripta en Mercado Pago, con sus cobros (la forma de resumen() con mp y cobros).
function suscripcionConCobros(estado, cobros) {
    return {
        ...suscripcionDePrueba(estado, 30),
        link: {
            init_point: 'https://www.mercadopago.com.ar/subscriptions/checkout?preapproval_id=prueba',
            url: 'https://app.transferisok.com/suscripcion/pruebaprueb',
            cobro_desde: '2026-11-05',
            email: 'cliente.mp@ejemplo.com',
            monto: 29000,
        },
        mp: { status: 'authorized', proximo_cobro: '2027-01-05' },
        cobros,
    };
}

// Cuentas inventadas para ver el listado de la barra del administrador general.
const NEGOCIOS_DE_PRUEBA = [{
    collector_id: '111',
    nombre: 'Verdulería de prueba',
    mp: { tipo: 'oauth', status: 'active' },
    limite_operadores: 100000,
    alias: 'verduleria.prueba',
    // Como uno que llegó solo por el CVU: visible salvo que se apague en Mi Perfil.
    mostrar_alias: true,
    alias_por: 'supervielle',
    titular: 'Dueña Ana Maria',
    usuarios: [
        { email: 'duenia@ejemplo.com', fullName: 'Ana Dueña', rol: 'principal', admin: true },
        ...OPERADORES_DE_PRUEBA.map(o => ({ ...o, fullName: o.nombre, rol: o.admin ? 'administrador' : 'operador' }))
    ],
    suscripcion: suscripcionDePrueba('prueba', 3)
}, {
    collector_id: '222',
    nombre: 'Kiosco de prueba',
    mp: { tipo: 'oauth', status: 'active', email: 'kiosco.mp@ejemplo.com' },
    usuarios: [{ email: 'kiosco@ejemplo.com', fullName: 'Carlos Kiosco', rol: 'principal', admin: true }],
    suscripcion: suscripcionDePrueba('por_cobrar', 9)
}, {
    collector_id: '333',
    nombre: 'Pinturería de prueba',
    mp: { tipo: 'oauth', status: 'active' },
    usuarios: [{ email: 'pintura@ejemplo.com', fullName: 'Laura Pintura', rol: 'principal', admin: true }],
    suscripcion: null
}, {
    collector_id: '444',
    nombre: 'Almacén de prueba',
    mp: { tipo: 'manual', status: 'active' },
    usuarios: [{ email: 'almacen@ejemplo.com', fullName: 'Pedro Almacén', rol: 'principal', admin: true }],
    suscripcion: suscripcionDePrueba('bonificada', 40)
}, {
    collector_id: '555',
    nombre: 'Frutería suscripta de prueba',
    mp: { tipo: 'oauth', status: 'active' },
    usuarios: [{ email: 'fruta@ejemplo.com', fullName: 'Marta Fruta', rol: 'principal', admin: true }],
    suscripcion: suscripcionConCobros('suscripta', [
        { fecha: '2026-11-05', monto: 29000, resultado: 'aprobado', motivo: null, reintenta_hasta: null }
    ])
}, {
    collector_id: '666',
    nombre: 'Panadería con cobro rechazado',
    mp: { tipo: 'oauth', status: 'active' },
    usuarios: [{ email: 'pan@ejemplo.com', fullName: 'Juan Pan', rol: 'principal', admin: true }],
    suscripcion: suscripcionConCobros('cobro_rechazado', [
        { fecha: '2026-12-05', monto: 29000, resultado: 'reintentando', motivo: 'fondos insuficientes', reintenta_hasta: '2026-12-15' },
        { fecha: '2026-11-05', monto: 29000, resultado: 'aprobado', motivo: null, reintenta_hasta: null }
    ])
}];

// Imita adminSuscripcion sin backend: alcanza para ver los estados y los botones.
function simularSuscripcion(actual, accion, datos) {
    const hoy = hoyAR();
    if (accion === 'generar_link') {
        const base = actual || suscripcionDePrueba('prueba', 0);
        return {
            ...base,
            estado: 'link_listo',
            link: {
                init_point: `https://www.mercadopago.com.ar/subscriptions/checkout?preapproval_id=prueba-${Date.now()}`,
                url: `https://app.transferisok.com/suscripcion/prueba${String(Date.now()).slice(-7)}`,
                cobro_desde: datos.cobro_desde,
                email: datos.email,
                monto: base.monto,
            },
        };
    }
    const haceDias = (fecha) => Math.round((Date.parse(`${hoy}T00:00:00Z`) - Date.parse(`${fecha}T00:00:00Z`)) / 86400000);
    if (accion === 'iniciar' || accion === 'cambiar_inicio') {
        const dias = haceDias(datos.inicio);
        const base = actual?.dias_prueba || 7;
        return suscripcionDePrueba(actual?.estado === 'bonificada' ? 'bonificada' : dias >= base ? 'por_cobrar' : 'prueba', dias, base);
    }
    const dias = haceDias(actual.inicio);
    if (accion === 'extender') {
        const total = Math.max(actual.dias_prueba, dias) + datos.dias;
        return suscripcionDePrueba(actual.estado === 'bonificada' ? 'bonificada' : 'prueba', dias, total);
    }
    if (accion === 'bonificar') return { ...actual, estado: 'bonificada' };
    if (accion === 'conciliar') return actual;
    return suscripcionDePrueba(dias >= actual.dias_prueba ? 'por_cobrar' : 'prueba', dias, actual.dias_prueba);
}

function TestModal() {
    const [showModal, setShowModal] = useState(false);
    const [showOperators, setShowOperators] = useState(true);
    const [successMessage, setSuccessMessage] = useState(null);
    // Límite de la cuenta (mp_accounts.limite_operadores) para ver los dos casos.
    const [limiteCuenta, setLimiteCuenta] = useState(100000);
    // Como la vista por usuario del superadmin (los cambios igual quedan en pantalla).
    const [verComo, setVerComo] = useState(false);
    const [negocios, setNegocios] = useState(NEGOCIOS_DE_PRUEBA);
    const [showPerfil, setShowPerfil] = useState(false);

    const handleSuccess = (message) => {
        setSuccessMessage(message);
        setTimeout(() => {
            setSuccessMessage(null);
        }, 3000);
    };

    return (
        <div style={{
            padding: '20px',
            maxWidth: '800px',
            margin: '0 auto',
            fontFamily: 'Studio-Feixen-Sans, Arial, sans-serif'
        }}>
            <h1>Página de prueba de operadores</h1>

            <VistaComoBar
                negocios={negocios}
                cargando={false}
                error={null}
                miEmail="super@ejemplo.com"
                onElegir={() => {}}
                onBaja={() => {}}
                onRecargar={() => {}}
                onFijarLimite={async () => {}}
                onFijarAlias={async (collectorId, alias) => {
                    setNegocios((actuales) => actuales.map((n) => (n.collector_id === collectorId ? { ...n, alias } : n)));
                }}
                onSuscripcion={async (collectorId, accion, datos) => {
                    await new Promise((r) => setTimeout(r, 300));
                    setNegocios((actuales) => actuales.map((n) => (
                        n.collector_id === collectorId ? { ...n, suscripcion: simularSuscripcion(n.suscripcion, accion, datos) } : n
                    )));
                }}
            />

            {/* El cartel del home con el alias del primer negocio de la barra. */}
            {negocios[0].alias && negocios[0].mostrar_alias !== false && (
                <div className="transactions-grid" style={{ padding: '20px 0' }}>
                    <AliasCuenta alias={negocios[0].alias} titular={negocios[0].titular} />
                    <div className="transactions-header">Transferencias recibidas en las últimas 24hs</div>
                </div>
            )}

            <label style={{ display: 'block', marginBottom: '20px' }}>
                <input
                    type="checkbox"
                    checked={!!limiteCuenta}
                    onChange={(e) => setLimiteCuenta(e.target.checked ? 100000 : null)}
                />{' '}
                La cuenta tiene límite para operadores ($100.000)
            </label>

            <label style={{ display: 'block', marginBottom: '20px' }}>
                <input
                    type="checkbox"
                    checked={verComo}
                    onChange={(e) => setVerComo(e.target.checked)}
                />{' '}
                Verla como administrador general
            </label>

            {successMessage && (
                <div style={{
                    padding: '10px',
                    backgroundColor: '#e8f5e9',
                    color: '#2e7d32',
                    borderRadius: '4px',
                    marginBottom: '20px'
                }}>
                    {successMessage}
                </div>
            )}

            <button
                onClick={() => setShowOperators(true)}
                style={{
                    backgroundColor: '#001c4d',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    padding: '12px 24px',
                    fontSize: '16px',
                    cursor: 'pointer',
                    marginRight: '12px'
                }}
            >
                Gestión de operadores
            </button>

            <button
                onClick={() => setShowModal(true)}
                style={{
                    backgroundColor: '#001c4d',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    padding: '12px 24px',
                    fontSize: '16px',
                    cursor: 'pointer'
                }}
            >
                Agregar operador
            </button>

            <button
                onClick={() => setShowPerfil(true)}
                style={{
                    backgroundColor: '#001c4d',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    padding: '12px 24px',
                    fontSize: '16px',
                    cursor: 'pointer',
                    marginLeft: '12px'
                }}
            >
                Mi perfil
            </button>

            {/* Mi Perfil del admin de la verdulería: el alias cambia el cartel de arriba. */}
            <ProfileModal
                isOpen={showPerfil}
                onClose={() => setShowPerfil(false)}
                currentUser={{ businessName: negocios[0].nombre, email: 'duenia@ejemplo.com' }}
                onLogout={() => setShowPerfil(false)}
                alias={negocios[0].alias}
                mostrarAlias={negocios[0].mostrar_alias !== false}
                onGuardarAlias={async (alias) => {
                    await new Promise((r) => setTimeout(r, 300));
                    setNegocios((actuales) => actuales.map((n, i) => (i === 0 ? { ...n, alias } : n)));
                }}
                onMostrarAlias={async (mostrar) => {
                    await new Promise((r) => setTimeout(r, 300));
                    setNegocios((actuales) => actuales.map((n, i) => (i === 0 ? { ...n, mostrar_alias: mostrar } : n)));
                }}
            />

            <AddOperatorModal
                isOpen={showModal}
                onClose={() => setShowModal(false)}
                onSuccess={handleSuccess}
                limiteCuenta={limiteCuenta}
            />

            <OperatorsModal
                isOpen={showOperators}
                onClose={() => setShowOperators(false)}
                operadoresDePrueba={OPERADORES_DE_PRUEBA}
                verComo={verComo ? 'admin@ejemplo.com' : undefined}
                limiteCuenta={limiteCuenta}
            />
        </div>
    );
}

export default TestModal; 